"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetWebMessengerConfiguration = exports.isUseGetTenantApplicationsWebMessengerConfigurationEnabled = void 0;
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _presentationHttp = require("@ori/presentation-http");
var _presentationUtils = require("@ori/presentation-utils");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _utils = require("../utils");
const isUseGetTenantApplicationsWebMessengerConfigurationEnabled = ({
  customerTypeId,
  isAuthenticated,
  relativeUrl,
  visitorSegment
}) => !!relativeUrl && (!isAuthenticated || customerTypeId !== undefined && visitorSegment !== undefined);
exports.isUseGetTenantApplicationsWebMessengerConfigurationEnabled = isUseGetTenantApplicationsWebMessengerConfigurationEnabled;
const useGetWebMessengerConfiguration = () => {
  const {
    customerId
  } = (0, _auth.useToken)();
  // istanbul ignore next -- No need to test undefined tenant case.
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    customerTypeId,
    visitorSegment
  } = (0, _presentationHttp.useGetCustomerInfo)({
    customerId
  });
  const isAuthenticated = (0, _auth.isAuthenticatedCustomer)(customerId);
  // istanbul ignore next -- No need to test isSSR.
  const relativeUrl = (0, _presentationUtils.isSSR)() ? undefined : (0, _utils.removeLanguageFromRelativeUrl)(window.location.pathname);
  return (0, _staticApiClientReact.useGetTenantApplicationsWebMessengerConfiguration)(tenant, {
    customerTypeId,
    relativeUrl,
    visitorSegment
  }, {
    swr: {
      enabled: isUseGetTenantApplicationsWebMessengerConfigurationEnabled({
        customerTypeId,
        isAuthenticated,
        relativeUrl,
        visitorSegment
      }),
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    },
    request: {
      validateStatus: _fetching.validateStatus
    }
  });
};
exports.useGetWebMessengerConfiguration = useGetWebMessengerConfiguration;
